import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ButtonComponent, SkeletonComponent } from '@webapp/ui';
import { ApiKeyRow } from '../../../interfaces/api-keys.interface';

@Component({
	selector: 'app-api-keys-list',
	standalone: true,
	imports: [DatePipe, ButtonComponent, SkeletonComponent],
	templateUrl: './api-keys-list.component.html',
	styleUrl: './api-keys-list.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApiKeysListComponent {
	rows = input<ApiKeyRow[]>([]);
	loading = input<boolean>(false);
	error = input<boolean>(false);

	create = output<void>();
	retry = output<void>();
	delete = output<ApiKeyRow>();
}
